import { useState } from "react"
import cx from "classnames"
import { useData } from "./hooks/data"
import { useCardArea } from "./hooks/useCardArea"
import { useListaEsperaView } from "./hooks/useListaEsperaView"
import { buildDisponibilidadSlides, buildListaEsperaSlides } from "./utils/slideBuilders"
import CarouselGroup from "./components/carousel-group"
import NoticesSection from "./components/notices-section/NoticesSection"
import Turno from "./components/turno/Turno"
import DisponibilidadProvider from "./providers/DisponibilidadProvider"
import "./Disponibilidad.css"

function DisponibilidadContent(): JSX.Element {
    const { ref: cardSectionRef, area: cardArea } = useCardArea()
    const { loading, logo, items, img_promo_horizontal, img_promo_vertical, escala_cards, lista_espera, folio_turn, folio_anuncio, avisos, pie_pagina } = useData(cardArea)
    const { isOpen: openListaEspera, openWindow: abrirListaEspera } = useListaEsperaView()
    const [activeSlide, setActiveSlide] = useState(1)

    const disponibilidadSlides = buildDisponibilidadSlides({ items, logo, escala: escala_cards })

    const listaEsperaSlides = !openListaEspera
        ? buildListaEsperaSlides({
            listaEspera: lista_espera,
            escala: escala_cards,
            onListaEsperaTitleClick: abrirListaEspera,
            showExternalLinkIcon:true,
        })
        : []

    const allSlides = [...disponibilidadSlides, ...listaEsperaSlides]

    const shouldShowListaEsperaTitleInNotices =
        !openListaEspera &&
        activeSlide > items.length

    return (
        <div className="disp__screen">
            <div className="disp__content">
                <div className="disp__card-section" ref={cardSectionRef}>
                    <CarouselGroup
                        className={cx(pie_pagina ? "disp__carousel" : "")}
                        key={openListaEspera ? "abierta" : "cerrada"} 
                        onPageChange={setActiveSlide}
                    >
                        {allSlides}
                    </CarouselGroup>
                    {pie_pagina && <p className="disp__pie-pagina">{pie_pagina}</p>}
                </div>

                <NoticesSection
                    logo={logo}
                    loading={loading}
                    imgPromoH={img_promo_horizontal}
                    imgPromoV={img_promo_vertical}
                    showListaEsperaTitle={shouldShowListaEsperaTitleInNotices}
                    onListaEsperaTitleClick={abrirListaEspera}
                    showExternalLinkIcon={shouldShowListaEsperaTitleInNotices}
                    folioTurn={folio_turn}
                    avisos={avisos}
                />

                {!openListaEspera && (
                    <Turno 
                        folioTurno={folio_anuncio}
                        size="large"
                        showDuration={10000}
                        isModal={true}
                        ready={!loading}
                    >
                        <span>Pregunta al personal por tu habitación.</span>
                    </Turno>
                )}

                {pie_pagina && <p className="disp__pie-pagina-vertical">{pie_pagina}</p>}
            </div>
        </div>
    )
}

function Disponibilidad(): JSX.Element {
    return (
        <DisponibilidadProvider>
            <DisponibilidadContent />
        </DisponibilidadProvider>
    )
}

export default Disponibilidad